import React, { createContext, useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

export const AccessContext = createContext();

const AccessProvider = ({ children }) => {
    const { instance } = useMsal();
    const [canContribute, setCanContribute] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [accessLoading, setAccessLoading] = useState(true);

    useEffect(() => {
        const accounts = instance.getAllAccounts();
        const userEmail = accounts[0]?.username?.toLowerCase();

        if (!userEmail) {
            setAccessLoading(false);
            return;
        }

        const checkAccess = async () => {
            try {
                const acceptedRes = await fetch("https://prod.appstudioltts.com/api/requestpage/acceptedrequest");
                const acceptedData = await acceptedRes.json();

                const isAccepted = acceptedData.some(
                    (item) => item.Email?.toLowerCase() === userEmail
                );
                console.log("Is Accepted", isAccepted)
                if (isAccepted) {
                    setCanContribute(true);
                    setInProgress(false);
                } else {
                    const skillsRes = await fetch("https://prod.appstudioltts.com/api/skills/skillsview");
                    const skillsData = await skillsRes.json();

                    const isPending = skillsData.some(
                        (item) => item.Email.toLowerCase() === userEmail
                    );

                    setInProgress(isPending);
                    setCanContribute(false);
                }
            } catch (err) {
                console.error("Access check failed:", err);
                setCanContribute(false);
                setInProgress(false);
            } finally {
                setAccessLoading(false);
            }
        };

        checkAccess();
    }, [instance]);

    return (
        <AccessContext.Provider value={{ canContribute, inProgress, accessLoading }}>
            {children}
        </AccessContext.Provider>
    );
};

export default AccessProvider;
